<template>
    <div id="create-brand-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Add Version</h1>
                <VersionForm @formSubmitted="createVersion" />
            </section>
        </div>
    </div>
</template>

<script>
import VersionForm from '@/components/forms/VersionForm.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/versions/create'
import axios from 'axios'

export default {
    name: 'VersionsCreate',
    components: {
        VersionForm
    },
    data: function() {
        return {

        }
    },
    methods: {
        createVersion(fd) {
            axios.post(endpoint, fd)
                  .then(response => {
                      console.log(response)
                      alert('Version created successfully')
                      this.$router.push('/versions')
                  })
                  .catch(error => {
                      console.log(error.response)
                      if (error.response && error.response.data?.data) {
                          alert(error.response.data.data)
                      }
                      else {
                          alert('Error occurred!')
                          console.log(error)
                      }
                  })

        }
    }
}
</script>

<style lang="scss" scoped>
</style>
